import React from "react";
import { object } from "prop-types";
import get from "lodash/get";

import NewsWithImage from "../../molecules/NewsWithImage";
import LeftImageRightNews from "../../molecules/LeftImageRightNews";
import DfpAd from "../../dfp-ad";

import "./bigVideoStoryCard2Ad.m.css";

const BigVideoStoryCard2Ad = ({ collection }) => {
  const stories = collection.items.filter((item) => item.type === "story" && item.story).map(({ story }) => story);
  if (!stories.length) {
    return null;
  }

  const adSlotId1 = get(collection, ["associated-metadata", "ad_slot_id1"], "default_ad_slot1");
  const adSlotId2 = get(collection, ["associated-metadata", "ad_slot_id2"], "default_ad_slot2");

  const firstStory = stories[0];

  return (
    <div styleName="wrapper">
      <NewsWithImage
        cssStyleName="bigSize"
        story={firstStory}
        aspectRatio={[16, 9]}
        imageType="image16x9"
        widths={[1000]}
      />
      <div>
        <div styleName="side-ad">
          <DfpAd adtype="News_336x280_R1" slotId={adSlotId1} />
        </div>
        {stories.splice(1, 3).map((story, index) => (
          <LeftImageRightNews story={story} key={index} aspectRatio={[16, 9]} imageType="image16x9" />
        ))}
      </div>
      <div styleName="horizontal-ad">
        <DfpAd adtype="News_728x90_T1" slotId={adSlotId2} />
      </div>
    </div>
  );
};

BigVideoStoryCard2Ad.propTypes = {
  story: object,
  collection: object,
};

BigVideoStoryCard2Ad.storyLimit = 4;

export default BigVideoStoryCard2Ad;
